module.exports = __webpack_public_path__ + "img/arrow.c99feb09.png";